export default function EFChecked(props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" {...props}>
            <g id="check-list" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="check-list-B-1" transform="translate(-567.000000, -597.000000)" fillRule="nonzero">
                    <g id="编组-2" transform="translate(399.000000, 359.000000)">
                        <g id="选中态" transform="translate(168.000000, 238.000000)">
                            <circle id="椭圆形" fill="currentColor" cx="15" cy="15" r="15"></circle>
                            <polygon
                                id="Fill-1"
                                fill="#FFFFFF"
                                points="12.1841707 17.7951873 8.89825977 14.5325809 7.5 15.9308407 12.1841707 20.6150114 21.8321659 10.9670182 20.4339068 9.54545455"
                            ></polygon>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
